<template>
  <v-row>
    <v-col sm="6" class="pt-0">
      <div class="list-container" v-if="emails.length > 0 && !initialLoading">
        <tag
          v-for="(item, index) in emails"
          :key="index"
          :text="item"
          data-class="dynamicTagsdark"
          :showDelete="true"
          @click="removeEmail(item)"
        ></tag>
      </div>
      <div class="list-container d-flex" v-if="initialLoading">
        <v-skeleton-loader
          v-for="(item, index) in 5"
          :key="index"
          type="chip"
          class="pr-2"
          :loading="true"
        ></v-skeleton-loader>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
    name: 'EmailTagsContainer',
    props: ['emails','initialLoading'],
    methods: {
        removeEmail(item) {
            this.$emit('removeEmail',item);
        }
    }
};
</script>